import 'react-phone-number-input/style.css'
import text from '../text.json'
import {Input as CustomInput} from '../../../components/core/input'
import {isValidPhoneNumber} from 'react-phone-number-input'
import Input from 'react-phone-number-input/input'
import {SimpleBlueButton} from '../../../components/core/button'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import {Formik} from 'formik'
import {useEffect, useState} from 'react'
import {channelTypeSchema} from '../../../utils/validation'
import {addChannel, setAddedChannel} from '../../../stores/customer-settings'
import {useDispatch, useSelector} from 'react-redux'
import channelTypes from '../../../data/channelTypes.json'
import LimitManager from '../../../utils/limitManager'
import CustomSelect from '../../../components/core/customSelect'
import {SmsIcon} from '../../../icons'
import classNames from 'classnames'
import localStorageKeys from '../../../utils/localStorageKeys'
import RenderedForPaid from '../../../components/pages/RenderedForPaid'
import plans from '../../../data/plans.json'
import usageLimits from '../../../data/usageLimits.json'

const AddNotificationChannel = ({closeModal, setModalData, getNotificationChannelCount, customerId}) => {
    const [buttonIsDisabled, setButtonIsDisabled] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const currentPlan = localStorage.getItem(localStorageKeys.PLAN)
    const [active, setActive] = useState(null)
    const addedChannel = useSelector(state => state.customer_settings.addedChannel)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const isSMSChannelDisabled = !LimitManager.getSMSChannelIsEnabled()

    const dispatch = useDispatch()

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const channelTypeElement = (value, label, isDisabled, icon) => {
        return {value, label, isDisabled, icon}
    }

    const channelTypeOptions = [
        channelTypeElement(channelTypes.types.sms, 'Phone number (SMS)', isSMSChannelDisabled, <SmsIcon/>)
    ]

    const initialFormValues = {
        type: !isSMSChannelDisabled ? channelTypeOptions[0] : '',
        value: ''
    }

    const fieldNames = {
        channel_type: 'type',
        channel_value: 'value'
    }

    const validateNumber = () => {
        if (!isValidPhoneNumber(phoneNumber)) {
            setButtonIsDisabled(true)
            return text.number_is_not_valid
        }
        return setButtonIsDisabled(false)
    }

    const addNotificationChannel = async(values, {setFieldError, resetForm}) => {
        setIsSubmitting(true)
        const success = await dispatch(addChannel(false, customerId, {
            type: values.type.value,
            value: phoneNumber
        }, setFieldError, resetForm))
        setIsSubmitting(false)
        if (success) {
            closePopup()
        }
    }

    const getPaidText = values => {
        const channelLimit = LimitManager.getSMSChannelLimit()
        const channelType = values.type.label
        const channelCount = getNotificationChannelCount(channelTypes.types.sms)
        return  LimitManager.getLimitDiff(usageLimits.limit_keys.per_user_sms_channel_count.limit_key, channelCount) > 0 && text.for_paid_channel
            .replace(':channel_limit', channelLimit)
            .replace(':channel_type', channelType)
            .replace(':channel_count', LimitManager.getLimitDiff(usageLimits.limit_keys.per_user_sms_channel_count.limit_key, channelCount))
    }

    const isExceeded = () => {
        return LimitManager.getSMSChannelLimit() === getNotificationChannelCount(channelTypes.types.sms)
    }

    const closePopup = () => {
        setPhoneNumber('')
        closeModal()
    }
    useEffect(() => {
        if (addedChannel?.priority) {
            setModalData(prev => ({
                ...prev,
                status: true,
                codeModal: true,
                value: phoneNumber,
                type: channelTypes.types.sms,
                channel: addedChannel
            }))
            dispatch(setAddedChannel({}))
        }
    }, [addedChannel])

    const isDisabled = isExceeded() || currentPlan === plans.free_v2.key

    return (
        <Formik initialValues={initialFormValues}
            enableReinitialize={true}
            onSubmit={addNotificationChannel}
            validationSchema={channelTypeSchema}
            validateOnBlur={false}
            validateOnChange={false}>
            {({errors, handleSubmit, setFieldValue, setErrors, values}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    {values.type.value &&
                    <RenderedForPaid
                        forPaidText={getPaidText(values) || text.for_paid_general}
                        isExceeded={isExceeded()}
                        isTextWithLimits={!!getPaidText(values)}/>}
                    <CustomSelect
                        placeholder={text.channel_type}
                        onChange={setFieldValue}
                        infoText={text.type_info}
                        value={values.type}
                        name={fieldNames.channel_type}
                        options={channelTypeOptions}
                        activeInfo={active === fieldNames.channel_type}
                        handleInfo={(state) => handleInfo(fieldNames.channel_type, state)}
                        error={errors.type}
                    />
                    {values.type.value === channelTypes.types.sms && (
                        <CustomInput
                            customInput={
                                <Input
                                    className={classNames('simple-input', {
                                        dark: isDarkMode
                                    })}
                                    disabled={isDisabled}
                                    placeholder={text.phone_number}
                                    name={fieldNames.channel_value}
                                    value={phoneNumber}
                                    onChange={e => {
                                        setPhoneNumber(e)
                                        setErrors({})
                                    }}
                                />
                            }
                            infoText={text.phone_info}
                            activeInfo={active === fieldNames.channel_value}
                            handleInfo={(state) => handleInfo(fieldNames.channel_value, state)}
                            error={(phoneNumber?.length > 0 && validateNumber()) || errors.value}
                        />
                    )}
                    {isSMSChannelDisabled &&
                        <RenderedForPaid forPaidText={text.for_paid} isExceeded={false}/>}
                    <SimpleBlueButton
                        type="submit"
                        disabled={buttonIsDisabled || isSubmitting || isDisabled}>
                        {isSubmitting && <ButtonLoader/>}
                        {text.submit}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default AddNotificationChannel
